export const PRESS_CTA_BTN = "cta_btn";
export const PRESS_CONTACT_BTN = "contact_btn";
export const SUBMIT_CONTACT_FORM = "submit_contact";
export const SUBMIT_BOOK_MEETING_FORM = "book_meeting";
export const SUBMIT_APPLY_JOB_APPLICATION_FORM = "submit_job_application";
